<template>
<div @click="hasTooltip()" class="container">
<div class="container" style="padding-left:0px"><h3 style="margin-top:5px;margin-bottom:5px">  <a href="javascript:;" @click="goHome()">Home ></a> <a href="javascript:;" @click="goSearchSitters(sitterPublicDetailComp.SitterId)">Search Sitters ></a> <a style="text-decoration: none">{{sitterPublicDetailComp.Name}}</a></h3> </div>
<div class="container some-style" v-if="sitterPublicDetailComp">
</br>
  
  <div class="col-sm-7">
  <div class="bgWrap">
  <div class="col-sm-12 bgCover " v-bind:style="{ backgroundImage: 'url(' + bgImageComp + ')' }">
    <div class="photo-images">
      <div class="thumb-wrap"  v-if="photo.Type!=0" v-for="(photo,index) in sitterPublicDetailComp.SitterPhotoDtos">
      <a  :href="photo.Path" data-fancybox="images">
            <img class="small-images" :src="photo.Path"></img>
      </a>
        
      </div>
      </div>
  </div>
  </div>
  <div>
    </br>
    <div class="row">
      
  <div class="col-xs-12 hidden-sm hidden-md hidden-lg"> <!-- needs bootstrap re-order instead of this workaround-->
    <div class="row">
      <div class="col-xs-12" >
        <div class="media-body">
          <div class="media-left">
            <img :src="sitterPublicDetailComp.ProfilePicUrl" alt="" class="media-object img-responsive img-rounded" height="100" width="100"></img>
                        <div  @click="viewProfile(sitter)" style="cursor:pointer" v-if="sitterPublicDetailComp.IsOnline==true" class="rank-label-container">
                                <span class="label label-default rank-label" > Online</span>
                        </div>
          </div>
          <div class="media-left head-title">
            <h2 class="media-heading main-name">{{sitterPublicDetailComp.Name}}</h2>
              <h6><i class="fa fa-map-marker"></i> {{LocationComp}}</h6>
            <div v-if="sitterPublicDetailComp.RatingCount>0" >
              
              <i class="fa fa-star fa-1x inline" style="color:#ffd118" v-for="n in sitterPublicDetailComp.RatingAvg"/>
               <h6 class=" inline"> {{sitterPublicDetailComp.RatingCount}} {{reviewString(sitterPublicDetailComp.RatingCount)}}</h6>
            </div>
          </div>
          
        </div>
        <a class="hidden-xs hidden-sm media-right media-top"  data-toggle="popover" data-trigger="hover" data-container="body" data-placement="top" data-content="Add or Remove from Favorites" @click="addToFavorites(sitterPublicDetailComp)" lazy><i v-bind:class="[{'fa-heart': isFavorite(sitterPublicDetailComp.SitterId)==true}, {'fa-heart-o': isFavorite(sitterPublicDetailComp.SitterId)==false}]" class="fa favorite fa-2x " aria-hidden="true"/></a>
        <a class="hidden-md hidden-lg media-right media-top"   @click="addToFavorites(sitterPublicDetailComp)" lazy><i v-bind:class="[{'fa-heart': isFavorite(sitterPublicDetailComp.SitterId)==true}, {'fa-heart-o': isFavorite(sitterPublicDetailComp.SitterId)==false}]" class="fa favorite fa-2x " aria-hidden="true"/></a>
      </div>

    </div>
    
    <div>
    <div class="row">
      <div v-if="sitterPublicDetailComp.IsActive==true" @click="premiumSwal()" class="alert alert-premium" >
          <h3 style="margin:0px; " class="text-center"> Premium Member <i class="fa fa-paw"/> </h3>
      </div>
      </div>
    <div style="margin-top:10px;">
    <h5 class="performance" v-if="!sitterPublicDetailComp.AverageResponseTime==0"><i class="fa fa-clock-o" ></i> Average Response Time: {{sitterPublicDetailComp.AverageResponseTime}}</h5>
    <h5 class="performance" v-if="!sitterPublicDetailComp.ResponseRate==0"><i v-if="sitterPublicDetailComp.ResponseRate>90" class="fa fa-thumbs-o-up"/> Response Rate: {{sitterPublicDetailComp.ResponseRate}}%</h5>
    <h5 class="performance" v-if="sitterPublicDetailComp.LastOnline  && sitterPublicDetailComp.IsOnline==false"> Last Seen: {{lastSeenDate(sitterPublicDetailComp.LastOnline)}}</h5>
    <h5 class="performance" v-if="!sitterPublicDetailComp.RepeatedStays==0"><i class="fa fa-handshake-o" ></i> Number of Repeated Clients: {{sitterPublicDetailComp.RepeatedStays}}</h5>
    
    
    
    </div>
     
      <div>
      <h3  class="text-success"><i class="fa fa-id-badge"/> Offered Services </h3>
      </div>
     <table class="table-condensed col-xs-12" v-for="item in sitterPublicDetailComp.SitterServiceDtos">
        <thead>
          <tr>
          </tr>
        </thead>
        <tbody>
          <tr v-if="item.IsOffered">
            <td style="padding-top: 0px; padding-bottom: 0px;" class="h4 col-xs-7">{{item.Description}} <i v-if="item.ServiceType<=4" class="fa fa-question-circle" style="font-size:12px;color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Boarding (sitter's home), Sitting (parent's home)."></i></td><td style="padding-top: 0px; padding-bottom: 0px;" class="h4 col-xs-5"><strong>{{item.Price}}</strong> <span style="font-size:14px;">{{item.DescriptionPer}}</span></td>
          </tr>
        </tbody>
      </table>
      
    </div>
  </div>
  <div class="col-xs-12 hidden-sm hidden-md hidden-lg">
      <button style="margin-top:10px!important;" class="btn btn-success btn-lg  btn-block btn-title" @click="contactSitter()">Contact {{sitterPublicDetailComp.FirstName}} <i class="fa fa-commenting-o"></i></button>
        <div style="margin-top:10px;" class="text-center">
      <a href="javascript:;" @click="howBookingWork()">How booking or meet and greet work?</a>
      </div>

  </div>
  <div class="col-xs-12">
    
    <h3 class="text-success"> <i class="fa fa-address-card-o"/> Profile Details </h3>
    <h4>{{sitterPublicDetailComp.Title}}</h4>
    <p  style="white-space: pre-wrap; ">{{sitterPublicDetailComp.AboutMe}}</p>
        <div v-if="petPrefComp.Restrictions">
        <h4> {{sitterPublicDetailComp.Name}} Restrictions</h4>
        
        <p style="white-space: pre-wrap;">{{petPrefComp.Restrictions}}</p>
        </div>

       <div v-if="petPrefComp.Experience">
        <h4> {{sitterPublicDetailComp.Name}} Experience with animals</h4>
        
        <p style="white-space: pre-wrap;">{{petPrefComp.Experience}}</p>
        </div>
      </div>

      <div class="col-sm-10 col-xs-12" v-if="sitterPublicReviewsComp">
        <h3 class="text-success"> <i class="fa fa-thumbs-o-up"/> Reviews</h3>
        </br>
        <div>
          <div class="media" v-for="(review,index) in sitterPublicReviewsComp">
            <div class="media-left">
              <img :src="review.ReviewerPicUrl" alt="" class="img-responsive img-rounded img-min-size" height="75" width="75"></img>
            </div>
            <div class="media-left head-title" >
                <h4 class="media-heading " style="margin-bottom:0px;">{{review.ReviewerName}}</h4>
                                <div>
                <i class="fa fa-star fa-1x" style="color:#ffd118" v-for="n in review.Rating"/>
                <p style="font-size:small; margin-top:0px; margin-bottom:0px;"> Posted {{review.ReviewDate}}</p>
                </div>
            </div>
            <br>
            <p> {{review.Description}} </p>  
            <hr v-if="index!=sitterPublicReviewsComp.length-1" />
          </div>
          
        </div>
      
      </div>
    </div>
    
    
    <div v-if="sitterPublicDetailComp.IsDogWalking" class="col-sm-12" >
    <div class="row">
      <h3 class="text-success"> <i class="fa fa-paw"/> Dog Walking</h3>
        <h4>Walking during the following days</h4>
       <label v-if="sun>0"  class="small " style="font-weight:300">
            <span>Sun</span>
        </label>
                   
        <label v-if="mon>0" class="small " style="font-weight:300">
            Mon
        </label>
                   
        <label v-if="tue>0" class="small " style="font-weight:300">
            Tue
        </label>
                   
        <label v-if="wed>0" class="small " style="font-weight:300">
            Wed
        </label>
                   
        <label v-if="thu>0" class="small" style="font-weight:300">
            Thu
        </label>
                   
        <label v-if="fri>0" class="small " style="font-weight:300">
            Fri
        </label>
                   
        <label v-if="sat>0" class="small " style="font-weight:300">
            Sat
        </label>

        <div v-if="sitterPublicDetailComp.DogWalkingAreas.length>0">
         <h4>Walking for the following locations only:</h4>
          <label v-for="(area,index) in sitterPublicDetailComp.DogWalkingAreas" class="small " style="font-weight:300">
            {{area.AreaName}} <span v-show="index!=sitterPublicDetailComp.DogWalkingAreas.length-1">,</span>
        </label>
        </div>

        <div v-if="sitterPublicDetailComp.DogWalkingRemarks!=null">
         <h4>Dog Walking Restrictions and Details:</h4>
          <p style="white-space: pre-wrap;">{{sitterPublicDetailComp.DogWalkingRemarks}} </p>
          
        </div>
      </div>
    </div>
    
    <div class="col-sm-12" v-if="homeDetailsComp">
      <div class="row">
        <h3 class="text-success"> {{sitterPublicDetailComp.Name}}'s Home</h3>


         <div class="fancy-container" v-if="homeDetailsComp.HomeType==0">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Studio Apartment</span>
        </div>

        
         <div class="fancy-container" v-if="homeDetailsComp.HomeType==1">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> 1 Bedroom Apartment</span>
        </div>

        
         <div class="fancy-container" v-if="homeDetailsComp.HomeType==2">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> 2 Bedroom Apartment</span>
        </div>

        <div class="fancy-container" v-if="homeDetailsComp.HomeType==3">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> 3 Bedroom Apartment </span>
        </div>

        <div class="fancy-container" v-if="homeDetailsComp.HomeType==4">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Townhouse </span>
        </div>
      
        <div class="fancy-container" v-if="homeDetailsComp.HomeType==5">
            <span><img src="./images/House.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Villa </span>
        </div>
      
        <div class="fancy-container" v-if="!homeDetailsComp.IsSmokeFree">
            <span><img src="./images/Smoke.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Smoking allowed at home</span>
                    
        </div>
        
       <div class="fancy-container" v-if="homeDetailsComp.IsHasChildren">
            <span><img src="./images/HasChildren.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Children at home</span>
                    
        </div>
        
       <div class="fancy-container" v-if="homeDetailsComp.IsHasCat">
            <span><img src="./images/ResidentCat.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Resident cat at home</span>
                    
        </div>
        
         <div class="fancy-container" v-if="homeDetailsComp.IsHasDog">
            <span><img src="./images/ResidentDog.png" class="icon-image" height="25" width="25"></img></span>
            <span class="h4 "> Resident dog at home</span>
                    
        </div>
        
        <h3 v-if="hasSkillsComp" class="text-success"> {{sitterPublicDetailComp.Name}}'s Skills</h3>

         <div class="fancy-container" v-if="petPrefComp.CanCPR">
          <span><img src="./images/CPR.png" class="icon-image" height="25" width="25"></img></span>
          <span class="h4 "> CPR First Aid</span>
        </div>

        <div class="fancy-container" v-if="petPrefComp.CanOral">
          <span><img src="./images/oral.png" class="icon-image" height="25" width="25"></img></span>
          <span class="h4 "> Oral Mediciation</span>
        </div>
        <div class="fancy-container" v-if="petPrefComp.CanInject">
          <span><img src="./images/inject.png" class="icon-image" height="25" width="25"></img></span>
          <span class="h4 "> Can provide injections</span>
        </div>
     
      </div>
    </div>  



  </div>
  </div>
  

  <div class="col-sm-5 hidden-xs">
    <div class="row">
      <div class="col-sm-12" >
        <div class="media-body">
          <div class="media-left">
            <img :src="sitterPublicDetailComp.ProfilePicUrl" alt="" class="media-object img-responsive img-rounded" height="100" width="100"></img>
              <div  @click="viewProfile(sitter)" style="cursor:pointer" v-if="sitterPublicDetailComp.IsOnline==true" class="rank-label-container">
                                <span class="label label-default rank-label" > Online</span>
                        </div>
          </div>
          <div class="media-left head-title">
            <h2 class="media-heading main-name">{{sitterPublicDetailComp.Name}}</h2>
              <h6><i class="fa fa-map-marker"></i> {{LocationComp}}</h6>
            <div v-if="sitterPublicDetailComp.RatingCount!=0" >
              
              <i class="fa fa-star fa-1x inline" style="color:#ffd118" v-for="n in sitterPublicDetailComp.RatingAvg"/>
               <h6 class=" inline"> {{sitterPublicDetailComp.RatingCount}} {{reviewString(sitterPublicDetailComp.RatingCount)}}</h6>
            </div>
          </div>
        
          
        </div>
         
         <a class="hidden-xs hidden-sm media-right media-top"  data-toggle="popover" data-trigger="hover" data-container="body" data-placement="top" data-content="Add or Remove from Favorites" @click="addToFavorites(sitterPublicDetailComp)" lazy><i v-bind:class="[{'fa-heart': isFavorite(sitterPublicDetailComp.SitterId)==true}, {'fa-heart-o': isFavorite(sitterPublicDetailComp.SitterId)==false}]" class="fa favorite fa-2x " aria-hidden="true"/></a>
        <a class="hidden-md hidden-lg media-right media-top"   @click="addToFavorites(sitterPublicDetailComp)" lazy><i v-bind:class="[{'fa-heart': isFavorite(sitterPublicDetailComp.SitterId)==true}, {'fa-heart-o': isFavorite(sitterPublicDetailComp.SitterId)==false}]" class="fa favorite fa-2x " aria-hidden="true"/></a>
      </div>

    </div>
    <div class="row">
      <div v-if="sitterPublicDetailComp.IsActive==true" @click="premiumSwal()" class="alert alert-premium-lg" style="  border-color: rgb(229, 221, 232);;margin-top:7px; cursor:pointer">
          <h3 style="margin:0px;margin-left:12px; " class="text-center"> Premium Member <i class="fa fa-paw"/> </h3>
      </div>
    </div>
    <div>
    <div style="margin-top:10px;">
    <h5 class="performance" v-if="!sitterPublicDetailComp.AverageResponseTime==0"><i class="fa fa-clock-o" ></i> Response Time: {{sitterPublicDetailComp.AverageResponseTime}}</h5>
    <h5 class="performance" v-if="!sitterPublicDetailComp.RepeatedStays==0"><i class="fa fa-handshake-o" ></i> Client Repeated Stays: {{sitterPublicDetailComp.RepeatedStays}}</h5>
    <h5 class="performance" v-if="!sitterPublicDetailComp.ResponseRate==0"><i v-if="sitterPublicDetailComp.ResponseRate>90" class="fa fa-thumbs-o-up"/> Response Rate: {{sitterPublicDetailComp.ResponseRate}}%</h5>
    <h5 class="performance" v-if="sitterPublicDetailComp.LastOnline && sitterPublicDetailComp.IsOnline==false">Last Seen: {{lastSeenDate(sitterPublicDetailComp.LastOnline)}}</h5>
    
    </div>


     <h3 class="text-success"><i class="fa fa-id-badge"/> Offered Services </h3>
     <table class="table-condensed col-xs-12"  v-for="item in sitterPublicDetailComp.SitterServiceDtos">
        <thead>
          <tr>
          </tr>
        </thead>
        <tbody>
          <tr v-if="item.IsOffered">
            <td style="padding-top: 0px; padding-bottom: 4px;" class="h4 col-xs-7">{{item.Description}} <i v-if="item.ServiceType<=4" class="fa fa-question-circle" style="font-size:12px;color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Boarding (sitter's home), Sitting (parent's home)."></i></td><td style="padding-top: 0px; padding-bottom: 0px;" class="h4 col-xs-5"><strong>{{item.Price}}</strong> <span style="font-size:14px;">{{item.DescriptionPer}} </span></td> 
          </tr>
        </tbody>
      </table>
      
    </div>

      
      <button  class="btn btn-success btn-lg  btn-block " @click="contactSitter()">Contact {{sitterPublicDetailComp.FirstName}} <i class="fa fa-commenting-o"></i></button>
      <div style="margin-top:10px;" class="text-center">
       
      <a href="javascript:;" @click="howBookingWork()">How booking or meet and greet work?</a>
      </div>

  </div>

  <div class="col-sm-5 pull-right">
    <h3 class="text-success"> <i class="fa fa-check-square-o"/> Hosting Preferences</h3>
    <div>
      
        <div class="col-xs-12 wrapper" style="margin-bottom:5%" v-if="petPrefComp">
        
          <div class="preference-images">
          <figure  class=" cats ">
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Accepting Cats" class="img img-responsive pad-bottom" v-if="petPrefComp.AcceptCats" src="./images/cat.png"></img>
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Not Accepting Cats" class="img img-responsive pad-bottom" v-else="petPrefComp.AcceptCats" src="./images/nocat.png"></img>
            <figcaption class=" text-center">Cats </figcaption>
            
          </figure>
        </div>
        <div class="preference-images">
          <figure  class=" small-breeds">
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Accepting Small Dogs 0-6 KG" class="img img-responsive pad-bottom" v-if="petPrefComp.AcceptSmallDogs" src="./images/smallDog.png"></img>
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Not Accepting Small Dogs" class="img img-responsive pad-bottom" v-else="petPrefComp.AcceptSmallDogs" src="./images/nosmallDog.png"></img>
            <figcaption class=" text-center"> Small </figcaption>
          </figure>
        </div>
        <div class="preference-images">
          <figure  class=" medium-breeds ">
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Accepting Medium Size Dogs 7-18 KG" class="img img-responsive pad-bottom" v-if="petPrefComp.AcceptMediumDogs" src="./images/dog.png"></img>
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Not Accepting Medium Size Dogs" class="img img-responsive pad-bottom" v-else="petPrefComp.AcceptMediumDogs" src="./images/NoDog.png"></img>
            <figcaption class="text-center"> Medium </figcaption>
          </figure>
        </div>
        <div class="preference-images">
          <figure  class=" ">
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Accepting Large Dogs 19+ KG" class="img img-responsive pad-bottom" v-if="petPrefComp.AcceptLargeDogs" src="./images/largeDog.png"></img>
            <img data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Not Accepting Large Dogs" class="img img-responsive pad-bottom" v-else="petPrefComp.AcceptLargeDogs" src="./images/NolargeDog.png"></img>
            <figcaption class="text-center"> Large </figcaption>
          </figure>
          </div>
        </div>
    </div>


    <hr>
    <h3 class="text-success" > <i class="fa fa-calendar"/> Availability</h3>
    <CalendarView :sitterId="this.$route.params.sitterId"></CalendarView>
  
  </div>
  
</div>
  
    <div  v-if="sitterPublicDetailComp" class="hidden-md hidden-lg text-center">
      <a href="javascript:;"  @click="goSearchSitters(sitterPublicDetailComp.SitterId)"><h3>Back to Search Sitters</h3></a>
    </div>

<div v-if="errorMsg">
     <div class="alert alert-warning" v-if="errorMsg">
        <h4>{{ errorMsg }}</h4>
      </div>
</div>

<div v-if="!errorMsg">
  <div v-if="!sitterPublicDetailComp" class="container"><div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div></div>
  </div>
</div>

</template>

<script>


import auth from '../../auth'
import store from '../../data/store'
import CalendarView from './Profile/CalendarView.vue'
import commonApi from '../../services/commonApi'
import customerApi from '../../services/customerApi.js'

export default {
        name: 'profileView',
        data() {
            return {
              title: 'Dupaws Sitter Profile',
              number: 5,
              SitterPublicDetails: '',
              SitterPublicReviews: '',
              errorMsg: '',
               sun: 0,
            mon: 0,
            tue: 0,
            wed: 0,
            thu:0,
            fri:0,
            sat:0
              
            }
        },
      created(){
           if (this.$route.params.sitterId!=null){
            this.getSitterPublicDetails(this.$route.params.sitterId)
            this.getSitterPublicReviews(this.$route.params.sitterId)
           }
            
            
        },
        mounted(){
          
           $('[data-tooltip]').tooltip();

           if (this.$route.params.sitterId!=null){
             this.getSitterPublicDetails(this.$route.params.sitterId)
             this.getSitterPublicReviews(this.$route.params.sitterId)
             this.setSitterProfileView(this.$route.params.sitterId)
           }
          
          if (localStorage.getItem('userRole')=="Client")
          {
            customerApi.getPetsList()
          }
        },
        computed: {
       
        whatsappUrl: function(){
          return 'whatsapp://send?text=' + this.SitterPublicDetails.SitterMarketingUrl
        },
        twitterUrl: function(){
            return 'https://twitter.com/share?url=' + this.SitterPublicDetails.SitterMarketingUrl + '&via=dupaws&hashtags=dupaws'
        },
        linkedinUrl: function(){
            return 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.SitterPublicDetails.SitterMarketingUrl + '&source=LinkedIn'
        },
        googleUrl: function(){
            return 'https://plus.google.com/share?url=' + this.SitterPublicDetails.SitterMarketingUrl
        },
        mailUrl: function(){
            return 'mailto:?subject=Just found the perfect pet sitter for you :)&body=' + this.SitterPublicDetails.SitterMarketingUrl
        },
            countryCurrencyComp: function(){
                return store.getters.CountryData.Currency
            },
            hasSkillsComp: function(){
              if (this.petPrefComp.CanCPR || this.petPrefComp.CanInject || this.petPrefComp.CanOral)
                  return true;
              else 
                  return false;
            },
            compProfilePic: function(){
                return store.getters.profilePicUrl
            },
            sitterPublicDetailComp: function(){
               return this.SitterPublicDetails
            },
            bgImageComp: function(){
              if (this.SitterPublicDetails.SitterPhotoDtos)
              if (this.SitterPublicDetails.SitterPhotoDtos.length>0)
                {
                  const index = this.SitterPublicDetails.SitterPhotoDtos.findIndex(t => t.Type === 0)
                  if (index != null && index!=-1) {
                      return this.SitterPublicDetails.SitterPhotoDtos[index].Path
                  } 
                }
            },
            LocationComp: function(){
              if (this.SitterPublicDetails.SitterLocationDtos)
              return this.SitterPublicDetails.SitterLocationDtos.CityName + ', ' + this.SitterPublicDetails.SitterLocationDtos.AreaName 
            },
            sitterPublicReviewsComp: function(){
              if (this.SitterPublicReviews.length==0){
                return null
              } else{
                return this.SitterPublicReviews
              }
            },
            petPrefComp: function(){
              if (this.SitterPublicDetails.PetPrefDtos){
                return this.SitterPublicDetails.PetPrefDtos
              }
            },
            homeDetailsComp: function(){
              if (this.SitterPublicDetails.HomeDetailDtos){
                return this.SitterPublicDetails.HomeDetailDtos
              }
            }
    
        },
        updated(){
          this.$ga.page(this.$router)
          $('[data-toggle="popover"]').popover();
    
          // $zopim(function (){
          //     $zopim.livechat.sendVisitorPath();
          // });
          $("[data-fancybox]").fancybox({
             selector : '[data-fancybox="images"]',
                  loop: true
          });
        },
        methods: {
          shareLinkedin: function(){
            var self = this
          this.$ga.event('Share Button Clicked', 'linkedin', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId)
            },
            shareWhatsApp: function(){
              var self = this
              this.$ga.event('Share Button Clicked', 'whatsup', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId)
            },
            shareGooglePlus: function(){
              var self = this
              this.$ga.event('Share Button Clicked', 'google+', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId)
            },
            shareMail: function(){
              var self = this
              this.$ga.event('Share Button Clicked', 'mail', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId)
            },
            hasTooltip(){

        $(function() {
            var HasTooltip = $('.hastooltip');
            HasTooltip.on('click', function(e) {
                e.preventDefault();
                var isShowing = $(this).data('isShowing');
                HasTooltip.removeData('isShowing');
                if (isShowing !== 'true')
                {
                HasTooltip.not(this).tooltip('hide');
                $(this).data('isShowing', "true");
                $(this).tooltip('show');
                }
                else
                {
                $(this).tooltip('hide');
                }

            }).tooltip({
                animation: true,
                trigger: 'manual'
            });
            });
        },
          reviewString: function(count){
            if (count==1)
                return 'Review'
            else 
                return 'Reviews'
        
          },
          howBookingWork: function(){
               swal({
                            title: 'Booking a Sitter',
                            text: "When you initiate a booking request, you will be able to chat or request meeting with the sitter before booking takes place. Additionally you can request more than 1 sitter at a time",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
          },
            shareFacebook: function(){
            var self = this
            this.$ga.event('Share Button Clicked', 'facebook', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId)
            var myQuote = self.sitterPublicDetailComp.Name + ' pet sitter page on Dupaws.com'
            FB.ui({
                method: 'share',
                href: self.sitterPublicDetailComp.SitterMarketingUrl,
                quote: myQuote,
                hashtag: '#dupaws',
                mobile_iframe: true,
                }, function(response){
                        if (response && !response.error_message){
                            
                        }
                        else {
                        
                }
            });
        },
        isFavorite: function(sitterId){   //Needs improvement, calling many times.
              if (this.userRoleComp=="Sitter")   //sitters cannot add another sitter, they need to login as clients
                    return false
              var result = $.grep(store.getters.FavoriteSitters, function(e){ return e.SitterId == sitterId })
              if (result.length>0)
                  return true
              else
                return false
          },
           lastSeenDate: function(lastSeenDate){
              return moment(lastSeenDate).fromNow()
          },
          contactSitter(){
            var self = this;
            
            if (store.getters.authenticated==false)
            swal({
              title: "Sign In",
              text: "You need to be logged in to Request a Reservation",
              type: "info",
              showCancelButton: true,
              confirmButtonClass: 'btn-success',
              confirmButtonText: "Login",
              closeOnConfirm: true,
              html: true
            }, function(){
              self.$router.push({path: '/login', query: {sitter: self.$route.params.sitterId}})
            });
            else if (store.getters.userRole!="Client")
            {
              swal("Hello",'You need to be logged in as a Customer to request reservation',"info");
            }
            else if (store.getters.PetsList.length<1)
               {
                  swal({
                      title: "No Pets Found",
                      text: "Please register your Pet details before contacting a Sitter",
                      type: "info",
                      showCancelButton: true,
                      confirmButtonClass: 'btn-info',
                      confirmButtonText: "Add Pets",
                      closeOnConfirm: true,
                      html: true
                    }, function(){
                      self.$router.push({path: '/pets-view/addpet', query: {sitter: self.$route.params.sitterId}})
                    });
               }
            else if (store.getters.SubscriptionStatus.IsActive==false && self.sitterPublicDetailComp.IsActive==false){
              self.sendBasicAccountCheck();
              fbq('track', "Lead", {content_name: 'Customer booking Basic Sitter request'});
              swal({
                title: "Subscription required",
                text: "To contact a non-premium pet sitter, you need to have an active membership.",
                type: "info",
                showCancelButton: true,
                confirmButtonClass: 'btn-success',
                confirmButtonText: "Subscribe",
                closeOnConfirm: true,
                html: true
              }, function(){
                self.$router.push({path: '/subscribe'})
              });
            }
            else if (store.getters.CountryData.CountryId!=this.sitterPublicDetailComp.SitterLocationDtos.CountryId)            
            {
              swal("Hello",'You cant contact Sitters that are in different country than yours, please change your country settings.',"info");
            }
            else {
               if (store.getters.PetsList.length<1)
               {
                  swal({
                      title: "No Pets Found",
                      text: "Please register your Pet details before contacting a Sitter",
                      type: "info",
                      showCancelButton: true,
                      confirmButtonClass: 'btn-info',
                      confirmButtonText: "Add Pets",
                      closeOnConfirm: true,
                      html: true
                    }, function(){
                      self.$router.push({path: '/pets-view/addpet', query: {sitter: self.$route.params.sitterId}})
                    });
               } else {
                 self.$router.push({path: '/reservation/' + self.$route.params.sitterId })
               }
            }
          },
          getSitterPublicDetails(sitterId) {
             var self = this;
              return $.ajax({
                  type: 'GET',
                  url: "https://www.dupaws.com/services/public/getSitterPublicDetails/" + sitterId,
                  dataType: "json",
                  crossDomain: true,
                  contentType: "application/json; charset=utf-8",
                  success: function(data) {
                      self.SitterPublicDetails = data
                      self.title = data.Name + ' ' + data.Title
                      if (data.IsDogWalking){
                         self.sun = data.DogWalkingDays & 1
                          self.mon = data.DogWalkingDays & 2
                          self.tue = data.DogWalkingDays & 4
                          self.wed = data.DogWalkingDays & 8
                          self.thu = data.DogWalkingDays & 16
                          self.fri = data.DogWalkingDays & 32
                          self.sat = data.DogWalkingDays & 64
                          }
                      self.$emit('updateHead')
                      
                  },
                  error: function(data, status, error) {
                      self.errorMsg = data.responseJSON.Message
                  }
              });
           },
          sendBasicAccountCheck(){
            var self = this
             $.ajax({
                    type: 'GET',
                    url: "https://www.dupaws.com/services/api/contactBasicAccount/" + self.$route.params.sitterId,
                    dataType: "json",
                    crossDomain: true,
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                      console.log(data)
                    },
                    error: function(data, status, error) {
                        console.log(data)
                    }
                });
          },
          setSitterProfileView(sitterId) {
             var self = this;
             if (store.getters.authenticated==false)
              $.ajax({
                    type: 'POST',
                    url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
                    dataType: "json",
                    crossDomain: true,
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                    },
                    error: function(data, status, error) {
                        self.errorMsg = data.responseJSON.Message
                    }
                });
              else if (store.getters.authenticated==true)
                {
                  $.ajax({
                    type: 'POST',
                     beforeSend: function(xhr){
                      xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
                    dataType: "json",
                    crossDomain: true,
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                    },
                    error: function(data, status, error) {
                        self.errorMsg = data.responseJSON.Message
                    }
                });
                }
           },
          premiumSwal: function(){
            swal({
                            title: 'Premium Member',
                            text: "You can contact and book Premium accounts directly without subscription or membership.",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            });
          },
           getSitterPublicReviews(sitterId) {
             var self = this;
              return $.ajax({
                  type: 'GET',
                  url: "https://www.dupaws.com/services/public/getSitterPublicReviews/" + sitterId,
                  dataType: "json",
                  crossDomain: true,
                  contentType: "application/json; charset=utf-8",
                  success: function(data) {
                      self.SitterPublicReviews = data
                  },
                  error: function(data, status, error) {
                      console.log("failed to get Sitter getSitterPublicReviews()" + data.responseText)
                  }
              });
           },
          goSearchSitters: function(sitterId){
              this.$router.push({path: '/findsitters#user' + sitterId })
          },
          goHome: function(){
              this.$router.push({path: '/'})
          },
          addToFavorites: function(sitter) {
            self = this;
            if (store.getters.authenticated==false)
              swal({
                title: "Hello",
                text: "You need to be logged in as a Customer to add sitters to your favorite account",
                type: "info",
                showCancelButton: true,
                confirmButtonClass: 'btn-success',
                confirmButtonText: "Login",
                closeOnConfirm: true,
                html: true
              }, function(){
                self.$router.push({path: '/login', query: {sitter: self.$route.params.sitterId}})
              });
              else if (store.getters.userRole=="Sitter"){
                swal("Hello",'You cant add Sitters as favorites while logged in as a Sitter, please switch to Customer login then try again' ,"info");
              }
              else {
                customerApi.addSitterToFavorites(sitter)
              }
            
      },
           
        },
        head: {
            // To use "this" in the component, it is necessary to return the object through a function
            title: function () {
              return {
                inner: this.title,
                
              }
            },
             meta: function() {
               return 
                  [
                    { name: 'application-name', content: 'Dupaws.com Sitter Profile' },
                    { name: 'description', content: this.title },
                    { name: 'keywords', content: this.title},
                    { property: 'fb:app_id', content: '279352372578608' },
                    { property: 'fb:admins', content:'636428053' },
                    { property: 'fb:pages', content:'1623158747696830' },
                  ]
                  }
        },
        components: {
          CalendarView
        }
                    
    
        
}
</script>

<style scoped>

.some-style{
    background-color: white;
    padding: 0px;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    border-radius: 5px;
    padding-bottom:20px;
    margin-bottom:3%;
}


.img-min-size{
  min-width:68px;
}

.cats {
  width:80%
}

.small-breeds{
  width:82%
}

.medium-breeds{
  width:90%
}

.large-breeds{
  width:100%
}

.pad-bottom{
  padding-bottom: 12px !important
}

.block {
  display: inline-block ;
}

.favorite {
    color:#af1818; opacity: 0.7;
    
}


 #social-fb {
     color: #3B5998;
 }
 #social-tw {
     color: #4099FF;
 }
 #social-gp {
     color: #d34836;
 }
 #social-ig {
     color: #974250;
 }

#social-wa {
    color:#4dc85c;
}

.social:hover {
     -webkit-transform: scale(1.1);
     -moz-transform: scale(1.1);
     -o-transform: scale(1.1);
 }
 .social {
     -webkit-transform: scale(0.8);
     /* Browser Variations: */
     
     -moz-transform: scale(0.8);
     -o-transform: scale(0.8);
     -webkit-transition-duration: 0.5s;
     -moz-transition-duration: 0.5s;
     -o-transition-duration: 0.5s;
 }


.btn-title{
  font-size:24px;
  font-family: 'Yanone Kaffeesatz', sans-serif;
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    
    transform: scale(1.1);
}


.table-custom {
    border-collapse: separate;
    white-space: nowrap;
    
}

.inline {
  display: inline-block ;
  vertical-align: baseline;
  padding-right: 1px
}

.fancy-container {
    
    border-radius: 6px;
    display: inline-block ;
    padding: 5px;
}

.my-icon {
    vertical-align: middle;
    font-size: 30px;
}



.rank-label-container {
    margin-top: -20px;
    
    /* z-index: 1000; */
    text-align: center;
}

.label.label-default.rank-label {
    background-color:rgb(92, 184, 92);
    padding: 5px 10px 5px 10px;
    border-radius: 27px;
}

.service-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size:large;
  font-weight:bold;
  color: grey;
}

.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.main-name{
  font-size: 24px;
  font-weight: bold;
  
}


.fa-check{
    color:green
}

.performance{
    padding: 2px 4px;
    font-size:smaller !important;
    margin: 5px 5px 6px 0px;
    display: inline-block;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    padding: 5px;
    
}
.bgCover {
   border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    border-radius: 5px;
    
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    
    padding-top:55.8%; 
  
}


.photo-images {
    position: absolute;
    bottom: 5px;
    margin-bottom: initial;
    right: 5px;
    left: 5px;
    display:flex;
    overflow:hidden;
}

.small-images {
    border: 1px solid #ddd;
    transition: all .1s ease-in;
    cursor: pointer;
    border-radius: 5px;
    display: inline-block ;
    max-width: 80%;
    height: auto;
}


.icon-image{
  vertical-align: sub;
}

.preference-images{
    max-width: 12%;
    margin:1vw;
    width:100px;
    min-width: 40px;
    display: inline-block ;
    padding: 2px;
}

.thumb-wrap {
    max-width: 20%;
    width:100px;
    min-width: 60px;
    display: inline-block ;
    padding: 2px;
}

.thumb-wrap:hover img{
    transform: scale(1.1);
    transition: all 1s ease-in;
    filter: brightness(.8);
}


.text-center{
    font-family: 'Yanone Kaffeesatz', sans-serif;     
    font-size: larger;
}

.wrapper{
  border:1px;
  border-style:solid;
  border-radius:5px;
  border-color:#c8c7c7;
  
}


	.ribbon-container {
				position: absolute;
				top: 55px;
				right: 0px;
				overflow: visible; /* so we can see the pseudo-elements we're going to add to the anchor */
				font-size: 14px; /* font-size and line-height must be equal so we can account for the height of the banner */
				line-height: 14px;
                border-radius: 1px;
			}
			
	.alert-premium {
        padding-top: 0px;
    padding-bottom: 0px;
    
     background-color: rgb(252, 249, 253);
    color: rgb(129, 159, 171);
    border-color: rgb(229, 221, 232);
    margin-top: 7px;
    margin-bottom: 0px;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    cursor: pointer;

  }
	
  .alert-premium-lg{
    padding-top: 0px;
    padding-bottom: 0px;
    
     background-color: rgb(252, 249, 253);
    color: rgb(129, 159, 171);
    border-color: rgb(158, 67, 187);
    margin-top: 7px;
    margin-left: 15px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-left: 1;
    margin-bottom: 0px;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
    border-right: 0;
    cursor: pointer;

  }

</style>


// WEBPACK FOOTER //
// SitterProfileView.vue?4166022e